import { ModelConfig } from './model-config';

export class BaseModel {

  private id: number;
  private attribs: object;

  private setPermittedAttribs() {

    // set bare attribs object.
    this.attribs = {};

    // loop config, setting permitted attrib object keys.
    for(var a in this.config.permittedAttribs)
    {
      this.attribs[this.config.permittedAttribs[a]] = null;
    }
  }

  protected load(attribs) {
    for(var a in attribs)
    {
      this.set(a, attribs[a]);
    }
  }

  public isNew() {
    return !this.id || isNaN(this.id);
  }

  public validProperty(prop) {
    return this.attribs.hasOwnProperty(prop);
  }

  public set(prop, val) {
    if(this.validProperty(prop))
    {
      this[prop] = val;
      return true;
    }

    return false;
  }

  public get(prop?: string) {
    if(!prop) { return this.attribs; }
    return this[prop];
  }

  constructor(private config: ModelConfig) {

    this.setPermittedAttribs();
  }
}



// WEBPACK FOOTER //
// ./src/models/base-model.ts